import React from 'react';
import {
    Breadcrumb,
    BreadcrumbItem,
} from '@appkit4/react-components/breadcrumb';
import './Breadcrumbs.scss';
import { useNavigate } from 'react-router-dom';

interface BreadcrumbsProps {
    items: {
        label: string;
        href?: string;
        processView?: {
            listingTab?: number;
            selectedDocTypes?: string[];
        };
    }[];
    onClick?: (index: number) => void;
    className?: string;
    style?: React.CSSProperties;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
    items,
    onClick,
    className,
    style,
}) => {
    const navigate = useNavigate();
    const goToPage = (item: any) => {
        navigate(item.href, {
            state:
                item.processView || { listingTab: 0, selectedDocTypes: [] } ||
                undefined,
        });
    };
    return (
        <div className="ita-breadcrumbs">
            <Breadcrumb className={className} style={style}>
                {items.map((item, index) => (
                    <BreadcrumbItem key={index}>
                        {index === items.length - 1 ? (
                            <span
                                aria-current="page"
                                className="breadcrumb-item-content ap-typography-body-m fw-bold"
                            >
                                <span
                                    className="Appkit4-icon icon-folder-closed-outline"
                                    aria-hidden="true"
                                ></span>
                                {item.label}
                            </span>
                        ) : (
                            <a
                                onClick={(e) => {
                                    if (onClick) {
                                        e.preventDefault();
                                        onClick(index);
                                    } else {
                                        goToPage(item);
                                    }
                                }}
                                className="breadcrumb-item-content ap-typography-body-m fw-bold"
                            >
                                <span
                                    className="Appkit4-icon icon-folder-closed-outline"
                                    aria-hidden="true"
                                ></span>
                                {item.label}
                            </a>
                        )}
                    </BreadcrumbItem>
                ))}
            </Breadcrumb>
        </div>
    );
};

export default Breadcrumbs;
